import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const DragonBetLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        width={127}
        height={30}
        className={className}
        viewBox='0 0 127 30'
        fill='#000'
    >
        <path
            fill='#E20613'
            d='M.398 9.18h5.955c4.805 0 7.749 3.24 7.749 7.817 0 4.576-2.944 7.817-7.749 7.817H.398V9.18Zm3.909 3.77v8.093h2c2.506 0 3.771-1.747 3.771-4.046 0-2.3-1.265-4.047-3.77-4.047H4.306ZM14.516 9.18h5.816c3.127 0 5.289 1.655 5.289 4.643 0 2.207-1.22 3.472-2.644 3.931 2.023 1.081 2.965 3.886 3.241 7.06H22.15c-.46-3.15-1.471-5.473-3.334-5.473h-.391v5.472h-3.908V9.18Zm5.793 3.77h-1.885v2.622h1.885c.76 0 1.287-.46 1.287-1.31 0-.851-.528-1.31-1.287-1.31v-.002Z'
        />
        <path
            fill='#E20613'
            d='M36.173 21.986h-5.219l-.943 2.828h-4.368L31.39 9.18h4.369l5.748 15.634h-4.369l-.966-2.828h.001Zm-3.93-3.771h2.666l-1.333-3.931-1.333 3.93ZM52.118 13.778c-1.034-.551-2.552-.943-4.207-.943-2.299 0-4.023 1.725-4.023 4.162 0 2.299 1.609 4.161 3.885 4.161 2.093 0 3.265-1.402 3.265-2.552v-.138H47.75v-3.541h7.31c.139.62.231 1.54.231 2.391 0 4.07-2.506 7.748-7.633 7.748-4.53 0-7.795-3.494-7.795-8.07 0-4.574 3.38-8.069 8.047-8.069 1.54 0 3.196.23 4.208.62v4.231Z'
        />
        <path
            fill='url(#dragonbet_a)'
            d='M82.597 16.859v7.955h-3.909V11.226l-1.08-1.794V9.18h4.597L88 18.01v-8.83h3.908v15.634H88l-5.403-7.955Z'
        />
        <path
            fill='fill'
            d='M93.453 9.18h5.84c2.943 0 4.966 1.724 4.966 4.207 0 1.678-.643 2.782-1.678 3.402 1.264.69 2.092 1.886 2.092 3.657 0 2.529-2.16 4.368-5.288 4.368h-5.932V9.18Zm5.817 3.77h-1.909v1.978h1.909c.598 0 .966-.345.966-.989 0-.643-.368-.989-.966-.989Zm.115 5.748h-2.024v2.345h2.024c.759 0 1.264-.391 1.264-1.173s-.505-1.173-1.264-1.173v.001ZM105.354 24.814V9.18h9.15v3.771h-5.242v2.093h4.782v3.771h-4.782v2.23h5.242v3.771h-9.15ZM118.848 12.95h-3.61V9.18h11.129v3.77h-3.61v11.864h-3.909V12.95Z'
        />
        <path
            fill='url(#dragonbet_b)'
            fillRule='evenodd'
            d='M77.902 16.411c0 6.127-5.066 10.998-11.379 10.898-6.076-.259-10.856-5.665-10.41-11.72.076-1.025.302-2.025.656-2.973a.029.029 0 0 0-.027-.039c-.191-.004-.538.16-1.165.544-.024.014-.055-.005-.049-.033.27-1.333 1.936-2.819 2.87-3.562.228-.182.05-.55-.233-.48a2.146 2.146 0 0 0-.641.282c-.025.016-.057-.008-.046-.036.462-1.196 1.566-1.941 1.845-2.114.023-.014.015-.05-.01-.054-2-.383-2.918-.502-3.148-2.764-.003-.027.027-.044.049-.029 1.956 1.337 4.328 1.195 6.582 1.397.659.06 1.353.104 1.964.377a3.22 3.22 0 0 1 1.463 1.288c.126.212.23.442.4.62.161.166.372.277.584.372.614.274 1.27.438 1.927.576.578.121 1.118.25 1.459.784.2.313.358.674.447.887.012.028-.021.053-.046.036-.535-.38-.854-.379-1.13-.199-.69.452-.64 1-1.32 1.355-.022.012-.05-.008-.044-.032.256-1.246-5.438-2.63-5.98-.83a.03.03 0 0 0 .019.036c1.005.385 1.877 1.56 3.63 1.491.024 0 .039.025.025.044-.167.224-.817 1.21-.248 2.32.007.015.002.035-.011.044-2.364 1.587.94-2.501-3.927-1.018a.036.036 0 0 0-.02.02c-.09.204-.165.416-.224.632-.006.022.015.043.037.036a9.423 9.423 0 0 1 1.769-.325c.035-.003.046.047.012.06-2.324.777-1.043 3.181 1.136 4.647.027.02.01.061-.022.056a24.1 24.1 0 0 1-2.575-.57c-.023-.006-.044.018-.034.04 1.543 3.677 6.752 4.379 9.178 1.1.913-1.234 1.148-2.622.924-4.025a.031.031 0 0 1 .032-.037c1.55.039 2.32-.738 2.738-1.058a.048.048 0 0 0-.004-.079c-1.498-.98-2.27-1.815-3.368-2.758a.033.033 0 0 1-.008-.036c.234-.504.725-.094.828-.744.34-2.147-3.32-2.98-4.188-3.243-1.5-.594-.57-1.153-2.755-2.214C72.724 4.664 77.9 10.078 77.9 16.41l.002.002ZM60.513 3.981c-2.04-.051-2.208-.603-3.158-1.29-.021-.015-.051.002-.048.027.09.837.309 1.667 1.244 2.068 1.329.567 2.79.29 3.792.363.023.002.038-.021.029-.042-.256-.608-.424-1.09-1.859-1.125Zm4.777 6.856c1.08 2.429 4.854 3.102 5.398 3.187.025.004.034.036.014.053l-.638.533c-.02.017-.01.049.014.053.277.038 1.447.15 3.716-.22.03-.004.035-.043.01-.056-1.698-.89-2.726-2.105-2.986-2.438-.02-.024-.057-.008-.053.024l.103.86a.03.03 0 0 1-.033.033c-3.148-.342-5.066-1.721-5.499-2.062-.024-.02-.059.007-.046.036v-.003Z'
            clipRule='evenodd'
        />
        <path
            fill='url(#dragonbet_c)'
            d='M77.851 17.42c-3.897 6.916-11.849 7.847-13.352 7.046 1.584-.466 5.224-1.617 6.307-3.437-3.653 1.365-7.277.51-8.71-2.523-.016-.035.016-.073.053-.062.74.21 1.586.398 2.552.562.03.005.046-.034.021-.05-2.186-1.468-3.448-3.863-1.14-4.651.035-.012.024-.066-.013-.063a9.363 9.363 0 0 0-1.772.326.025.025 0 0 1-.031-.031c.06-.222.13-.426.223-.635a.045.045 0 0 1 .024-.02c4.868-1.484 1.554 2.602 3.916 1.017.014-.01.02-.031.012-.046-.576-1.125.101-2.103.255-2.317.014-.019 0-.046-.025-.044-1.736.059-2.607-1.078-3.6-1.478-.037-.02-.059-.006-.037-.085.576-1.532 4.89-.65 5.84.438-.487-2.02-5.573-3.526-7.718-.513a.029.029 0 0 0 0 .033c.444.597 1.166.9 2.545 1.439a.029.029 0 0 1-.007.055c-2.798.003-2.914 2.082-2.727 3.333.192-.065.939-.34 1.095-.332.01-.005.023.006.019.018-.483 1.188.34 2.004.58 2.225.014.014.003.04-.018.04a4.186 4.186 0 0 1-2.056-.637c-.017-.011-.039.005-.034.025.142.498 1.231 4.056 3.947 5.242.025.011.019.048-.008.05-4.166.288-7.23-3.456-7.693-4.051-.015-.02-.047-.005-.043.02.509 2.744 2.069 5.182 4.256 6.828 2.996 2.284 5.948 2.167 6.009 2.168 3.9.121 10.28-2.174 11.328-9.889h.002Z'
        />
        <defs>
            <linearGradient
                id='dragonbet_a'
                x1='64.128'
                x2='85.096'
                y1='16.997'
                y2='16.997'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#E20613' />
                <stop offset='1' stopColor='#812326' />
            </linearGradient>
            <linearGradient
                id='dragonbet_b'
                x1='64.111'
                x2='85.106'
                y1='14.998'
                y2='14.998'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#E20613' />
                <stop offset='1' stopColor='#812326' />
            </linearGradient>
            <linearGradient
                id='dragonbet_c'
                x1='51.402'
                x2='97.218'
                y1='18.232'
                y2='18.232'
                gradientUnits='userSpaceOnUse'
            >
                <stop offset='.09' stopColor='#E20613' />
                <stop offset='.18' stopColor='#DD0713' />
                <stop offset='.28' stopColor='#CE0B16' />
                <stop offset='.4' stopColor='#B7121B' />
                <stop offset='.52' stopColor='#961C21' />
                <stop offset='.59' stopColor='#812326' />
            </linearGradient>
        </defs>
    </SvgElement>
);
